export const DotLoader = ({ size = "sm", color = "bg-gray-300" }) => {
  const sizeClasses = {
    xs: "w-1 h-1",
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  const dotClass = `block ${sizeClasses[size]} ${color}  rounded-full animate-bounce`;

  return (
    <div className="flex justify-end items-center">
      <div className="flex space-x-1">
        <span className={`${dotClass} [animation-delay:-0.32s]`}></span>
        <span className={`${dotClass} [animation-delay:-0.16s]`}></span>
        <span className={dotClass}></span>
      </div>
    </div>
  );
};
